import React from "react";
import middleware from "./middleware/middleware";
import AllPublisher from "../component/sections/publisher/AllPublisher";
import AddImage from "../component/sections/publisher/AddImage";

const sitesRoutes = [
  {
    path: "/publisher/all",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AllPublisher />,
        "AllPublisher"
      );
    },
    exact: true,
  },

  {
    path: "/publisher/:publisherID/add/image",
    render: () => {
      return middleware(
        ["isUserLogin", "isUserHasPublisherPermission"],
        <AddImage />,
        "AddImage"
      );
    },
    exact: true,
  },
];

export default sitesRoutes;
